import { useSelector } from 'react-redux';

const defaultMenuSettings = {
  showAddNewPatient: false,
};

export const useMenuSettings = () => {
  const { selectedTenancy } = useSelector((state) => state.clinicianProfile);
  if (!selectedTenancy) {
    return defaultMenuSettings;
  }

  const showAddNewPatient = !!(
    !selectedTenancy?.features?.menuSettings ||
    selectedTenancy?.features?.menuSettings?.showAddNewPatient
  );

  return {
    ...defaultMenuSettings,
    showAddNewPatient,
  };
};
